// number-format.directive.js
import Vue from 'vue';

Vue.directive('number-format', {
  bind(el, binding) {
    const inputType = binding.value || 'text'
    if (inputType !== 'number') return

    // 숫자와 소수점만 허용 (단, 소수점은 하나만)
    const format = (val) => {
      const rawVal = val.replace(/[^0-9.]/g, '')  // 숫자, 점만 남기기
                        .replace(/^([^.]*)\.?/g, (_, intPart) => intPart + '.')  // 소수점 하나 유지
                        .replace(/\.(?=.*\.)/g, '')  // 여러 개의 소수점 제거
      if (!rawVal) return ''
      
      const parts = rawVal.split('.')
      const integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      const float = parts[1]

      let _digit = ''
      if (integer !== '') _digit += integer
      if (integer !== '' && val.includes('.')) _digit += '.'
      else if (integer === '' && val.includes('.')) _digit += '0.'
      if (float !== '') _digit += float

      return _digit
    }

    let unformat = (val) => val.replace(/,/g, '')
    if (unformat === '.') {
      unformat = ''
    }

    const handler = (e) => {
      const start = el.selectionStart
      const beforeLength = el.value.length
      const unformatted = unformat(el.value)
      const formatted = format(unformatted)
      const afterLength = formatted.length

      if (el.value !== formatted) {
        el.value = formatted

        // 커서 위치 조정
        const cursorOffset = afterLength - beforeLength
        const newPos = start + cursorOffset

        // 커서 위치 복원
        setTimeout(() => {
          el.setSelectionRange(newPos, newPos)
        })

        const event = new Event('input', { bubbles: true })
        Object.defineProperty(event, 'target', {
          value: { value: el.value },
          enumerable: true,
        })
        el.dispatchEvent(event)
      }
    }

    el.addEventListener('input', handler)
  }
})
